import { isFeatureEnabled } from 'owa-feature-flags';

export function isCacheFirstEnabled(): boolean {
    return (
        isFeatureEnabled('rp-cacheFirstPeopleTrieSize300') ||
        isFeatureEnabled('rp-cacheFirstPeopleTrieSize500') ||
        isFeatureEnabled('rp-cacheFirstPeopleTrieSize700')
    );
}
